import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'semantic-ui-react';
import {Controller} from 'react-hook-form';
import {injectIntl, useIntl} from 'react-intl';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import './PhoneNumberField.scss';
import ReactPhoneInput from 'react-phone-input-material-ui';
import {MTextField} from "../../components/material/m-text-field";
import {TextField} from "@mui/material";

const PhoneNumberField = props => {
    const {name, required, label, error, disabled, defaultValue, requiredLabel} = props;
    console.log("props", props)
    const intl = useIntl();
    const fieldOptional = req => {
        if (req && requiredLabel) {
            return <span className="optional">(required)</span>;
        }
        if ((!req && requiredLabel) || (req && !requiredLabel)) {
            return '';
        }
        return <span className="optional">(optional)</span>;
    };

    return (
        <Controller
            render={({onChange: onValueChange}) => (
                <TextField
                    variant={'outlined'}
                    fullWidth
                    value={defaultValue}
                    label={label}
                    placeholder={intl.formatMessage({id: 'app.field.phone'})}
                    onChange={(_) => {
                        onValueChange(_.target.value)
                    }}
                    helperText={error && error.message}
                    required={required}
                    name={name}
                    />
                // <ReactPhoneInput
                //     inputProps={{
                //       label: intl.formatMessage({id: 'app.field.phone'}),
                //         name: name,
                //     }}
                //     onChange={onValueChange}
                //     value={defaultValue}
                //     defaultCountry={'gb'}
                //     component={TextField}/>

                )}
            rules={{
                required: {
                    value: required,
                    message: intl.formatMessage({id: 'validation.error.required'}, {name}),
                },
            }}
            name={name}
            defaultValue={defaultValue}
        />
    );
};

PhoneNumberField.propTypes = {
    name: PropTypes.string,
    required: PropTypes.bool,
    label: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.object]),
    disabled: PropTypes.bool,
    defaultValue: PropTypes.string,
    requiredLabel: PropTypes.bool,
};

PhoneNumberField.defaultProps = {
    name: '',
    required: false,
    label: '',
    error: null,
    disabled: false,
    defaultValue: '',
    requiredLabel: false,
};

export default injectIntl(PhoneNumberField);
